import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Visibility of npm packages depends on the scope (namespace) in which the package is contained, and the access level (private or public) set for the package.`}</p>
    <div className="note">
      <span className="bold">Note:</span> To create organization-scoped packages, you must first create an organization. For more information, see "<a href="https://docs.npmjs.com/creating-an-organization">Creating an organization</a>".
    </div>
    <h2>{`Public registry`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Scope`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Access level`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Can view and download`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Can write (publish)`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Org`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Private`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Members of a team in the organization with read access to the package`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Members of a team in the organization with read and write access to the package`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Org`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Public`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Everyone`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Members of a team in the organization with read and write access to the package`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`User`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Private`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The package owner and users who have been granted read access to the package`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The package owner and users who have been granted read and write access to the package`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`User`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Public`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Everyone`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The package owner and users who have been granted read and write access to the package`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Unscoped`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Public`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Everyone`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The package owner and users who have been granted read and write access to the package`}</td>
        </tr>
      </tbody>
    </table>
    <div className="note">
      <span className="bold">Note:</span> Only user accounts can create and manage unscoped packages. Organizations can only manage scoped packages.
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      